import { useParams } from '@tanstack/react-router';
import {
  PackageContentFilter,
  PackageContentList,
  PackageSummary,
  usePackageProposalContext
} from '@anytag/shared-organisms';
import { ListWithPagination } from '@anytag/shared-molecules';

export const PackageContentListDetails = () => {
  const params = useParams({ from: '/_private-routes/package/$id/content/list' });
  const { packageProposal, proposalSummary, loading } = usePackageProposalContext();

  const packageId = params.id;

  return (
    <>
      <PackageSummary proposalSummary={proposalSummary} packageId={Number(packageId)} />
      <ListWithPagination pagination={{ totalRecords: packageProposal?.totalCount || 0 }}>
        <PackageContentFilter loading={loading} />
        <PackageContentList packageId={Number(packageId)} loading={loading} />
      </ListWithPagination>
    </>
  );
};
